<template>
  <div class="mb-12">
    <div class="vx-row">
      <div class="vx-col sm:w-12/12 w-full">

        <div class="rental-manager-progress-bar-container">

          <vx-tooltip :text = startDate position="bottom" delay=".3s">Start</vx-tooltip>
          <vx-tooltip :text="actionTotal+' action(s)'" position="bottom" delay=".3s" :class = "(actionTotal > 0)?'':'active'">Action</vx-tooltip>
          <vx-tooltip :text="inviteesTotal+' invitees'"  position="bottom" delay=".3s" :class = "(inviteesTotal > 0)?'':'active'">Feedback</vx-tooltip>
          <vx-tooltip :text= motivationClass position="bottom" delay=".3s" :class = motivationClass>Motivation</vx-tooltip>
          <vx-tooltip text="Goal" position="bottom" delay=".3s" class="relative">
            <img  src="@/assets/images/icons/trophy.png" class="absolute" width="40" height="40" style="border-radius: 100%;top:-8px;left:-12px;">
          </vx-tooltip>
        </div>
      </div>
      <!-- <div class="vx-col sm:w-2/12 w-full">
        <img  src="@/assets/images/icons/trophy.png" class="mr-4 items-start" width="50" height="50" style="border-radius: 100%;">
      </div> -->

      </div>

  </div>

</template>

<script>
import VueSlideBar from "vue-slide-bar";
export default {
  name: "SteppedSlider",
  components: {
    VueSlideBar
  },
  methods: {
    callbackRange (val) {
      this.rangeValue = val
    },
    feedbackText(){
      console.log(this.slider.value);
      let f = this.slider.value;
      if (f >= 0 && f < 10) {
        this.feedback_text = "10/01/2022";
      } else if (f >= 10 && f < 20) {
        this.feedback_text = "10/01/2022";
      } else if (f === 20) {
        this.feedback_text = "10/01/2022";
      } else if (f > 20 && f <= 30) {
        this.feedback_text = "10/01/2022";
      } else if (f > 30 && f <= 40) {
        this.feedback_text = "10/01/2022";
      }
    },
    formatDate(createdAt) {
      let date = new Date(createdAt)
      date = `${date.getDate()  }-${  date.getMonth() + 1 }-${  date.getFullYear()}`;
      return date;
    },
  },
  data() {
    return {
      feedback_text: "",
      rangeValue: {},
      slider: {
        value: 11,
        data: [0, 10, 20, 30, 40,50,60,70,80,92,100],

      },
      startDate: "",
      actionTotal: "",
      inviteesTotal: "",
      motivationClass : "",
    };
  },
  created(){
    const traineeCompetenciesId = this.$route.params.traineeCompetenciesId;
    this.$store
        .dispatch("trainee-competencies/get", traineeCompetenciesId)
        .then(res1 => {
          this.startDate = this.formatDate(res1.createdAt)
          console.log("competency details", res1);
            this.$store.dispatch("competencyProgress/fetchCompetencyProgress", {query:{
              'traineeCompetenciesId':traineeCompetenciesId,
              }}).then(resMotivation => {
                if(resMotivation.total > 0){
                  if(new Date() > new Date(res1.motivationSurveyDate)) {this.motivationClass = 'skipped'}
                }
                else {
                  this.motivationClass = 'active'
                }
                console.log("motivation survey date is",res1.motivationSurveyDate);
              })
              .catch(err => {
                console.log("could not find competency details", err);
              });

          // if (res1.progressStatus === "in_progress") {
          //   this.progressStatus = "In Progress";
          //   this.progressStatusProp = "in_progress";
          // }
          // else if (res1.progressStatus === "complete") {
          //   this.progressStatus = "Goal Completed";
          //   this.progressStatusProp = "complete";
          // }
          //
          // const characteristicId = res1.competencyId.split("-")[0];
          // const competencyId = res1.competencyId.split("-")[1];
          // console.log(characteristicId, competencyId);
          // const competencies = this.CCD[characteristicId].competencies;
          // console.log(competencies);
          // const currentCompetency = competencies[competencyId];
          // console.log(currentCompetency);
          // this.currentCompetency = currentCompetency;
          // this.competency = currentCompetency.comp;
        })
        .catch(err => {
          console.log("could not find competency details", err);
        });

        this.$store
          .dispatch("development-actions/find",{query:{
            'traineeCompetenciesId':traineeCompetenciesId,

            }})
          .then(res1 => {
            this.actionTotal = res1.total;
          })
          .catch(err => {
            console.log("could not find competency details", err);
          });
        this.$store
          .dispatch("endorsement-invite/find",{query:{
              'traineeCompetenciesId':traineeCompetenciesId,
            }})
          .then(res1 => {
            this.inviteesTotal = res1.total;
          })
          .catch(err => {
            console.log("could not find competency details", err);
          });
  }

};
</script>

<style scoped>
.rental-manager-progress-bar-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-top: 5px solid rgba(var(--vs-primary),1);

  margin-top: 25px;
}


.active{
  background-color: lightgray !important;
}

.skipped{
  background-color: rgb(var(--vs-warning)) !important;
}

.rental-manager-progress-bar-container div {
  background-color: rgba(var(--vs-primary),1);
  font-weight: bold;
  color: rgba(var(--vs-primary),1);
  border: 2px solid rgba(var(--vs-primary),1);
  margin-top: -14px;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 65px;
  border-radius: 50%;
  z-index: 100;
}
</style>
